import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function WhatsappCampaignContent() {
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap={1} px={2} mt={2}>
      <Box sx={{ bgcolor: "#f0f3ff", borderRadius: "15px", p: "5px 10px", flex: 1, display: "flex", flexDirection: "column", gap: "5px" }}>
        <Box component="img" src="/assets/whatsapp_campaign_video.png" alt="" sx={{ borderRadius: "10px", height: 90, width: "100%", objectFit: "cover" }} />
        <Typography fontSize={12} fontWeight={500} color="#000">
          🎬 <strong>{t("comingSoon.whatsappCampaign.preview.video.title", "Behind the scenes of the brand.")}</strong>{" "}
          {t("comingSoon.whatsappCampaign.preview.video.body", "Discover how we create what you love so much. See you in store for the rest ❤️")}
        </Typography>
      </Box>
      <Box sx={{ bgcolor: "#f0f3ff", borderRadius: "15px", p: "5px 10px", flex: 1, display: "flex", flexDirection: "column", gap: "5px" }}>
        <Box component="img" src="/assets/whatsapp_campaign_picture.png" alt="" sx={{ borderRadius: "10px", height: 90, width: "100%", objectFit: "cover" }} />
        <Typography fontSize={12} fontWeight={500} color="#000">
          📸 <strong>{t("comingSoon.whatsappCampaign.preview.picture.title", "New product - come discover it!")}</strong>{" "}
          {t("comingSoon.whatsappCampaign.preview.picture.body", "Discover [product name] from today. Available exclusively in store 📍")}
        </Typography>
      </Box>
    </Stack>
  );
}
